import useTableUIStore from "@/store/tableUIStore";
import tradeBlockDataStore from "@/store/tradeBlockDataStore";
import React, { useEffect, useState } from "react";
import { getFontSizeClass } from "../../helper/actionSummaryHelper";
import {
  blocksContainNPV,
  blocksContainRecoupon,
} from "../../helper/tradeSettingsHelper/unwindSideRule";

const SelectPanelUnwindIndicator = ({ esid }: { esid: string }) => {
  const allBlockInfo = tradeBlockDataStore((state) => state.tradeBlockData);
  const fontSizeSetting = useTableUIStore((state) => state.fontSize);
  const fontSizeClass = getFontSizeClass(fontSizeSetting);

  const [NPVLegInTrade, setNPVLegInTrade] = useState(false);
  const [RecouponLegInTrade, setRecouponLegInTrade] = useState(false);

  // Update the trade to contain either NPV or Recoupon based on the legs endpoint.
  useEffect(() => {
    const thisBlockInfo = allBlockInfo.find((trades) => trades.esid == esid);
    if (thisBlockInfo) {
      if (thisBlockInfo.blocks && thisBlockInfo.blocks.length > 0) {
        setNPVLegInTrade(blocksContainNPV(thisBlockInfo.blocks));
        setRecouponLegInTrade(blocksContainRecoupon(thisBlockInfo.blocks));
      }
    }
  }, [allBlockInfo]);

  return (
    <div
      id="unwindFlagText"
      className={`flex items-center gap-1 pl-5 ${fontSizeClass} text-gray-700 dark:text-gray-300`}
    >
      {NPVLegInTrade || RecouponLegInTrade ? (
        <span>
          <span className="pr-1">Legs contain:</span>
          {NPVLegInTrade && RecouponLegInTrade ? (
            <span>Uwind (NPV & Recoupon)</span>
          ) : NPVLegInTrade ? (
            <span>NPV</span>
          ) : (
            <span>Recoupon</span>
          )}
        </span>
      ) : (
        ""
      )}
    </div>
  );
};

export default SelectPanelUnwindIndicator;
